import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AlarmCheck,
  InspectionAlarmtCase
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-check-alarms-case',
  templateUrl: './check-alarms-case.component.html',
  styleUrls: ['./check-alarms-case.component.scss']
})
export class CheckAlarmsCaseComponent implements OnInit {
  @Input() alarmCheck: AlarmCheck;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  selectedTab = 0;
  displayedColumns = ['accessory', 'nameAndLocation', 'address'];

  ngOnInit() {
    if (!(this.readonly || this.printPreview)) {
      this.displayedColumns.unshift('drag');
      this.displayedColumns.push('actions');
    }
  }

  addAlarm(): void {
    this.alarmCheck.alarms = [
      new InspectionAlarmtCase(),
      ...this.alarmCheck.alarms
    ];
    this.onChange();
  }

  removeAlarm(index: number): void {
    this.alarmCheck.alarms.splice(index, 1);
    this.alarmCheck.alarms = [...this.alarmCheck.alarms];
    this.onChange();
  }

  drop(event: CdkDragDrop<AlarmCheck[]>) {
    const prevIndex = this.alarmCheck.alarms.findIndex(
      (d) => d === event.item.data
    );
    moveItemInArray(this.alarmCheck.alarms, prevIndex, event.currentIndex);
    this.alarmCheck.alarms = [...this.alarmCheck.alarms];

    this.onChange();
  }

  onChange(): void {
    this.dataChange.emit();
  }
}
